import React, { useEffect } from "react";

export const useOutsideAlerter = (ref) => {
  const [outsideClickDetected, setOutsideClickDetected] = React.useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOutsideClickDetected(true);
      } else {
        setOutsideClickDetected(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  return outsideClickDetected;
};